import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=b8330128&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8330128')) {
      api.createRecord('b8330128', component.options)
    } else {
      api.reload('b8330128', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=b8330128&", function () {
      api.rerender('b8330128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/Choice/Form.vue"
export default component.exports